var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnpaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4.28147,
    fill: "#0066FF",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15101_8378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 33.0413C27.1047 33.0413 32.8642 27.2024 32.8642 19.9999C32.8642 12.7973 27.1047 6.9585 20 6.9585C12.8953 6.9585 7.13574 12.7973 7.13574 19.9999C7.13574 27.2024 12.8953 33.0413 20 33.0413Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4901 12.432C18.9152 12.0313 19.4148 11.8271 19.9891 11.8271C20.5707 11.8271 21.0704 12.0313 21.488 12.432C21.9056 12.8327 22.107 13.3165 22.107 13.8911C22.107 14.1708 22.0473 14.5942 21.9355 15.1461C21.8161 15.7055 21.6894 16.2726 21.5551 16.8547C21.3985 17.4898 21.227 18.276 21.0331 19.2135C20.8392 20.1509 20.6304 21.3228 20.4141 22.7365H19.5714C19.3552 21.3379 19.1464 20.1661 18.9525 19.221C18.7586 18.276 18.5796 17.4822 18.4304 16.8471C18.2738 16.1743 18.1396 15.5921 18.0352 15.0932C17.9308 14.5942 17.8786 14.1935 17.8786 13.8911C17.8562 13.3165 18.065 12.8327 18.4901 12.432ZM18.505 24.6644C18.9226 24.2561 19.4148 24.052 19.9741 24.052C20.5409 24.052 21.0331 24.2561 21.4507 24.6644C21.8684 25.0727 22.0772 25.5565 22.0772 26.1235C22.0772 26.683 21.8684 27.1668 21.4507 27.5675C21.0331 27.9682 20.5409 28.1723 19.9741 28.1723C19.4148 28.1723 18.9226 27.9682 18.505 27.5675C18.0874 27.1668 17.8786 26.683 17.8786 26.1235C17.8786 25.5641 18.0874 25.0802 18.505 24.6644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15101_8378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7284,
    height: 26.0828,
    fill: "white",
    transform: "translate(7.13574 6.9585)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/Unpaid.bfe07541fc3db3998674030542e76525.svg";
export { ForwardRef as ReactComponent };